import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { pathByRouteName } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { InlineTextButton, Logo, Heading, LayoutSingleColumn } from '../../components';

import css from './LoadableComponentErrorBoundary.module.css';

/**
 * @param {Object} props
 * @param {boolean} [props.isChunkLoadError] true for the original use — a stale
 *   client fetching a chunk the server no longer has — which gets the "app
 *   needs updating" copy; false for any other render error.
 */
export const LoadableComponentErrorBoundaryPage = props => {
  const { isChunkLoadError = true } = props;
  const routeConfiguration = useRouteConfiguration();
  const landingPagePath = pathByRouteName('LandingPage', routeConfiguration);
  const handleOnClick = () => {
    if (typeof window !== 'undefined') {
      window.location = landingPagePath;
    }
  };

  const landingPageLink = (
    <InlineTextButton onClick={handleOnClick}>
      <FormattedMessage id="LoadableComponentErrorBoundaryPage.landingPageLink" />
    </InlineTextButton>
  );

  return (
    <div>
      <LayoutSingleColumn
        topbar={
          <div className={css.topbar}>
            <InlineTextButton onClick={handleOnClick}>
              <Logo className={css.logoMobile} layout="mobile" />
              <Logo className={css.logoDesktop} layout="desktop" />
            </InlineTextButton>
          </div>
        }
        footer={null}
      >
        <div className={css.root}>
          <div className={css.content}>
            {isChunkLoadError ? <div className={css.number}>404</div> : null}
            <Heading as="h1" rootClassName={css.heading}>
              <FormattedMessage
                id={
                  isChunkLoadError
                    ? 'LoadableComponentErrorBoundaryPage.heading'
                    : 'LoadableComponentErrorBoundaryPage.renderErrorHeading'
                }
              />
            </Heading>
            <p className={css.description}>
              <FormattedMessage
                id={
                  isChunkLoadError
                    ? 'LoadableComponentErrorBoundaryPage.description'
                    : 'LoadableComponentErrorBoundaryPage.renderErrorDescription'
                }
                values={{ link: landingPageLink }}
              />
            </p>
          </div>
        </div>
      </LayoutSingleColumn>
    </div>
  );
};
